var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// db/room.ts
import MapBehaviorSubject from "@adornis/base/rxjs-extension/reactives/map.js";
import { ID } from "@adornis/baseql/baseqlTypes.js";
import { Entity, Field } from "@adornis/baseql/decorators.js";
import { AdornisEntity } from "@adornis/baseql/entities/adornisEntity.js";
import { currentMemberResolver } from "../server/resolver/memberID.js";
var createRoom = (roomID) => {
  return new Room({ _id: roomID, members: [] });
};
var Room = class extends AdornisEntity {
};
Room._class = "Room";
/** @deprecated dont use */
Room.rooms = new MapBehaviorSubject();
/** @deprecated dont use */
Room.createRoomIfNotPresent = true;
/** @deprecated dont use */
Room.fakeUserIDs = false;
__decorateClass([
  Field((type) => ID)
], Room.prototype, "_id", 2);
__decorateClass([
  Field((type) => ID, { resolve: currentMemberResolver })
], Room.prototype, "currentMember", 2);
__decorateClass([
  Field((type) => [ID])
], Room.prototype, "members", 2);
__decorateClass([
  Field((type) => ID)
], Room.prototype, "lastUpdateBy", 2);
Room = __decorateClass([
  Entity()
], Room);
export {
  Room,
  createRoom
};
